
angular.module('templates', []);

// main app
var app = angular.module('app',[
    'ngMessages'
    ,'ngSanitize'
    ,'ngAnimate'
    ,'angular-bind-html-compile'
    ,'pascalprecht.translate'
    ,'ui.bootstrap'
    ,'ui.slimscroll'
    ,'ngTagsInput'
    ,'smart-table'
    ,'oc.lazyLoad'
    ,'ivh.treeview'
    ,'monospaced.elastic'
    ,'templates'
    ,'gridster'
    ,'ui.sortable'
    ,'ja.qr'
    // ,'angularMoment'
    // ,'ui.router'
]);


// debug switch off
if(ENVIRONMENT=='production') {
    /*angular.module('app').config(['$compileProvider', function ($compileProvider) {
        $compileProvider.debugInfoEnabled(false);
    }]);*/
    // console.log('AngularJS Debug Mode should be Off, but we cannot do it yet due to jQuery ajax calls...');
} else {
    // console.log('AngularJS Debug Mode should be Off, but we cannot do it yet due to jQuery ajax calls...');
}

/*
angular.module('app').config(function($ariaProvider){
    $ariaProvider.config({
        ariaHidden: true, // Enables/disables aria-hidden tags
        ariaChecked: true, // Enables/disables aria-checked tags
        ariaDisabled: true,  // Enables/disables aria-disabled tags
        ariaRequired: true,  // Enables/disables aria-required tags
        ariaInvalid: true,  // Enables/disables aria-invalid tags
        ariaValue: true,  // Enables/disables aria-valuemin, aria-valuemax and aria-valuenow tags
        tabindex: true, // Enables/disables tabindex tags
        bindKeypress: true, // Enables/disables keypress event binding on div and li elements with ng-click
        bindRoleForClick: true,
    });
});
*/


// ANGULAR-VALIDATION
// Configure the Angular-Translate Provider (JSON)

// include validation languages
// if you want full localization add it in the suffix
// For example on Canadian French/English, we could replace the code by `suffix: '-CA.json'`
angular.module('app').config(['$translateProvider', '$translatePartialLoaderProvider',
    function ($translateProvider, $translatePartialLoaderProvider) {

        $translateProvider
            // .useLocalStorage()
            // .determinePreferredLanguage(function () { return 'en-GB'; })
            .useLoader('$translatePartialLoader', {
                urlTemplate: WEBAPP_PATH+'/js/angular/locales/{part}_{lang}.json?v=0.1'
            });
        // define translation maps you want to use on startup
        $translateProvider.preferredLanguage('en-GB');
        $translateProvider.use('en-GB');

        /*$translateProvider.useStaticFilesLoader({
            prefix: JS_PATH+'angular/locales/validation_',
            suffix: '.json'
        });*/

        /*$translateProvider.translations('en-GB', {
            TITLE: 'Hello',
            VALIDATION_MSG_INFO: 'Validation messages will appear in English (GB).'
        });*/
        /*$translateProvider.translations('pl', {
            TITLE: 'Hej',
            VALIDATION_MSG_INFO: 'Komunikaty walidacji w jezyku polskim.'
        });*/
    }
]);


// load default translation
angular.module('app').run(['$translatePartialLoader', function($translatePartialLoader) {
    $translatePartialLoader.addPart('default');
}]);

angular.module('app').run(['$rootScope', '$translate', function ($rootScope, $translate) {
    $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
        $translate.refresh();
    });
}]);


angular.module('app').config(['$provide', function($provide) {
    $provide.decorator('ngCloakDirective', ['$delegate', function ($delegate) {
        $delegate[0].priority = -1000;
        return $delegate;
    }]);
}]);


// SmartTable pagination template
angular.module('app').run(["$templateCache", function ($templateCache){
    // $templateCache.put('template/smart-table/pagination.html', '<nav ng-if="numPages && pages.length >= 2"><ul class="pagination">' + '<li><a ng-hide="currentPage==1" class="fa fa-angle-double-left" ng-click="selectPage(1)"></a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a ng-click="selectPage(page)">{{page}}</a></li><li><a ng-hide="currentPage==numPages" class="fa fa-angle-double-right" ng-click="selectPage(numPages)"></a></li>' + '</ul></nav>'); }]);

    $templateCache.put('template/smart-table/pagination.html', [
        '<div class="listing-pagination">'
            ,'<a href="javascript:void(0)" class="glyphicon glyphicon-fast-backward" role="button" title="First"'
                ,' ng-click="selectPage(1)" ng-disabled="currentPage==1"><span class="sr-only">First page</span></a>'
            ,'<a href="javascript:void(0)" class="glyphicon glyphicon-triangle-left" role="button" title="Previous page"'
                ,' ng-click="selectPage(currentPage-1)" ng-disabled="currentPage==1"><span class="sr-only">Previous page</span></a>'
            ,'<div class="form-inline">'
                ,'<div class="form-group">'
                    ,'<label class="control-label">Page {{currentPage}}</label>',
                    ,'<label class="control-label ng-binding"> of {{numPages}}</label>'
                ,'</div>'
            ,'</div>'
            ,'<a href="javascript:void(0)" class="glyphicon glyphicon-triangle-right" role="button" title="Next"'
                ,' ng-click="selectPage(currentPage+1)" ng-disabled="currentPage==numPages"><span class="sr-only">Next page</span></a>'
            ,'<a href="javascript:void(0)" class="glyphicon glyphicon-fast-forward" role="button" title="Last"'
                ,' ng-click="selectPage(numPages)" ng-disabled="currentPage==numPages"><span class="sr-only">Last page</span></a>'
        ,'</div>'].join('')
    );

}]);
// SmartTable enhancement
angular.module('smart-table').directive('stSort', [function(){
    return {
        restrict: 'A',
        require: '^stTable',
        link: function (scope, element, attr) {
            element
                .append('<span class="icon-sort icon-arrow-up"><span class="sr-only">ascending</span></span>')
                .append('<span class="icon-sort icon-arrow-down"><span class="sr-only">descending</span></span>')
                .addClass('sortable');
        }
    }
}]);

var transformToFormPost = function() {
    // I prepare the request data for the form post.
    function transformRequest( data, getHeaders ) {
        var headers = getHeaders();
        headers[ "Content-type" ] = "application/x-www-form-urlencoded; charset=utf-8";
        return( data );
    }
    return( transformRequest );
}
angular.module('app').factory('transformToFormPost', transformToFormPost);


/*
// not in use for now

// I provide a request-transformation method that is used to prepare the outgoing
// request as a FORM post instead of a JSON packet.
var transformJsonToFormPost = function() {
    // I prepare the request data for the form post.
    function transformRequest( data, getHeaders ) {
        var headers = getHeaders();
        headers[ "Content-type" ] = "application/x-www-form-urlencoded; charset=utf-8";
        return( serializeData( data ) );
    }
    // Return the factory value.
    return( transformRequest );
    // ---
    // PRVIATE METHODS.
    // ---
    // I serialize the given Object into a key-value pair string. This
    // method expects an object and will default to the toString() method.
    // --
    // NOTE: This is an atered version of the jQuery.param() method which
    // will serialize a data collection for Form posting.
    // --
    // https://github.com/jquery/jquery/blob/master/src/serialize.js#L45
    function serializeData( data ) {
        // If this is not an object, defer to native stringification.
        if ( ! angular.isObject( data ) ) {
            return( ( data == null ) ? "" : data.toString() );
        }
        var buffer = [];
        // Serialize each key in the object.
        for ( var name in data ) {
            if ( ! data.hasOwnProperty( name ) ) {
                continue;
            }
            var value = data[ name ];
            buffer.push(
                name + "=" + (( value == null ) ? "" : value)
                encodeURIComponent( name ) +
                "=" +
                encodeURIComponent( ( value == null ) ? "" : value )
            );
        }
        // Serialize the buffer and clean it up for transportation.
        var source = buffer
            .join( "&" )
            //.replace( /%20/g, "+" )
        ;
        console.log( source );
        return( source );
    }
}
angular.module('app').factory('transformJsonToFormPost', transformJsonToFormPost);
*/


// this is required for proper handling ajax calls redirections!
angular.module('app').run(['$http', function($http) {
    $http.defaults.headers.get = { 'X-Requested-With': 'XMLHttpRequest' };
    $http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=utf-8;Transfer-Encoding=chunked";
}]);



/* controllers */
(function() {

    'use strict';

    /**
    @ngdoc controller
    @name MainCtrl
    @description
    This is main controller. Please don't extend it - we use a thin main controller and directives based pattern
    (as per http://teropa.info/blog/2014/10/24/how-ive-improved-my-angular-apps-by-banning-ng-controller.html).
    */
    var MainCtrl = function($scope, $timeout, $compile, $translate, $translatePartialLoader, xmsNotificationFactory, helperFactory) {

        var vm = this;
        vm.compileElement = compileElement;

        // https://github.com/johnpapa/angular-styleguide#style-y033
        function compileElement( el ){
            $compile( el )( $scope );
        }
      //This uses the htmx afterSwap event to get angular js to pick up the content behave as expected
      //This should only be used for non user generated content otherwise it should only be used on sanitized content too
      document.addEventListener("htmx:afterSwap", function(event) {
        var newContent = event.detail.target;
        $compile(newContent)($scope);
        $scope.$digest();
      });



      // translate
        $translatePartialLoader.addPart('validation');
        vm.changeLanguage = function(key) {
            $translate.use(key);
            return false;
        };

        $scope.formModel          = {};
        $scope.pageModel          = {};
        $scope.listingModel       = {};
        $scope.multiactionModel   = {};

        $scope.pageModel.webappPath = WEBAPP_PATH; // just until XMS-9311 is done


        $scope.xmsNotifications = xmsNotificationFactory; // so you can use it with the click
        $scope.angularHelper    = helperFactory;

        /*
        this never worked (also requires $ocLazyLoad injection)
        $ocLazyLoad.load('ngCkeditor').then(function() {
            alert('loaded!');
            // $compile(angular.element('body'))($scope);
        });*/

        $scope.ocLoad = {
            ckeditor: {name:'ngCkeditor', files:[
                WEBAPP_PATH + '/js/vendor/angular/ng-ckeditor/ng-ckeditor.js',
                WEBAPP_PATH + '/js/vendor/CKEditor/ckeditor.js'
            ]},
            angularUiTree: {name:'angularUiTree', files:[
                WEBAPP_PATH + '/js/vendor/angular/angular-ui-tree/angular-ui-tree.min.js'
            ]}
            //,ovhTree: {name: 'ivh.treeview', files:['/js/vendor/angular/angular-ivh-treeview/dist/ivh-treeview.js']}
        };
	}
    //Explicitly inject $scope to avoid issues with code minification
    MainCtrl.$inject = ['$scope', '$timeout', '$compile', '$translate', '$translatePartialLoader', 'xmsNotificationFactory', 'helperFactory'];
	angular.module('app').controller('MainCtrl',MainCtrl);


    app.config(['ivhTreeviewOptionsProvider', function(ivhTreeviewOptionsProvider) {
        ivhTreeviewOptionsProvider.set({
            validate: true,
            twistieCollapsedTpl: '<span class="glyphicon glyphicon-menu-right"></span>',
            twistieExpandedTpl: '<span class="glyphicon glyphicon-menu-down"></span>',
            twistieLeafTpl: '',
            defaultSelectedState: false//,
            //nodeTpl: [
            //    '<div>',
            //        '<span ivh-treeview-toggle>',
            //            '<span ivh-treeview-twistie></span>',
            //        '</span>',
            //        '<ascii-box></ascii-box>',
            //        '<span class="ivh-treeview-node-label" ivh-treeview-toggle>',
            //            '{{::trvw.label(node)}}',
            //        '</span>',
            //        '<div ivh-treeview-children ng-if="trvw.isExpanded(node)></div>',
            //    '</div>'
            //].join('\n')
            ,nodeTpl: [ // node optimized for speed
                '<div class="ivh-treeview-node-content" title="{{::trvw.label(node)}}">',
                    '<span ivh-treeview-toggle>',
                        '<span class="ivh-treeview-twistie-wrapper" ivh-treeview-twistie></span>',
                    '</span>',
                    // '<span class="ivh-treeview-checkbox-wrapper" ng-if="trvw.useCheckboxes()"',
                    '<span class="ivh-treeview-checkbox-wrapper"',
                        'ivh-treeview-checkbox>',
                    '</span>',
                    '<span class="ivh-treeview-node-label" ivh-treeview-toggle>',
                        '{{::trvw.label(node)}}',
                    '</span>',
                    '<div ivh-treeview-children ng-if="trvw.isExpanded(node)"></div>',
                '</div>'
            ].join('\n')
        });
    }]);


}());


// this function is required to "angularize" (compile directive) content loaded by jQuery AJAX call
// TODO: to be removed after full jQuery 2 Angular rollout
function angularDirectiveCompile( element ) {
    if ( element !== undefined ) {
        element.removeAttribute("data-angular-compile"); // to make sure it's compiled only once
        var scope = angular.element( element.parentElement ).scope();
    	if(scope !== undefined) {
            console.log('compiling!');
    		scope.angularMainCtrl.compileElement( element );
    	}
    }
}

/*angular.module('app').run(["$templateCache", function($templateCache) {
    $templateCache.put('filter.html',
        '<tags-input ng-model="pageModel.filterTags" tags-string="pageModel.filterTagsString" replace-spaces-with-dashes="false" placeholder="Filter" on-tag-added="alertFn(\'test\')" on-tag-deleted="alertFn(\'test\')"></tags-input>'
    );
}]);*/

// Polyfill IE support
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function(valueToFind, fromIndex) {

            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            // 1. Let O be ? ToObject(this value).
            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(valueToFind, elementK) is true, return true.
                if (sameValueZero(o[k], valueToFind)) {
                    return true;
                }
                // c. Increase k by 1.
                k++;
            }

            // 8. Return false
            return false;
        }
    });
}

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}
